import { createContext } from "react";

export interface FeatureFlagsContextProps {
    featureFlags: string[];
    hasFlag(featureFlag: string): boolean;
}

export const FeatureFlagsContext = createContext<FeatureFlagsContextProps>(null!);